export default "__VITE_ASSET__DgB821sk__"